/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".border[_ngcontent-%COMP%] {\r\n    border-width:2px !important;\r\n}"];
export { styles as styles };
